<template>
  <div id="menu">
    <div class="logo">
      <router-link to="/avatamsaka">{{$t('avatamsaka.menu.webContra')}}</router-link>
    </div>

    <div class="buttonArea float-right ">
      <b-btn v-b-toggle.menuCollapse class="menuIcon">
        <span class="when-opened"><v-icon scale="2" name="bars" class="float-right"></v-icon></span>
        <span class="when-closed"><v-icon scale="2" name="bars" class="float-right"></v-icon></span>
      </b-btn>
    </div>

    <b-collapse id="menuCollapse">
      <b-btn v-b-toggle.menuCollapse class="float-right">
        <span class="when-opened"><v-icon scale="2" name="bars" class="float-right"></v-icon></span>
        <span class="when-closed"><v-icon scale="2" name="bars" class="float-right"></v-icon></span>
      </b-btn>
      <div class="menuList">
        <div class="linkArea">
      <ul>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/avatamsaka">
          {{$t('avatamsaka.other.avatamsaka')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/PurePractices">
          {{$t('avatamsaka.sutra01.title')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/TheTenBhumis">
          {{$t('avatamsaka.sutra02.title')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/chooseArticle">
          {{$t('avatamsaka.versions.articleRead')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/chooseContra">
          {{$t('avatamsaka.contrast.title')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/chooseCategory">
          {{$t('avatamsaka.category.title')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/chooseIntro">
          {{$t('avatamsaka.intro.title')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/download">
          {{$t('avatamsaka.download.title')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/about">
          {{$t('avatamsaka.menu.aboutContrast')}}
        </router-link></li>
        <li v-b-toggle.menuCollapse><router-link to="/avatamsaka/aboutTeam">
          {{$t('avatamsaka.menu.aboutTeam')}}
        </router-link></li>
      </ul>
      <ul class="language">
        <li v-b-toggle.menuCollapse @click="handleChangeLangBo">བོད་ཡིག</li>
        <li v-b-toggle.menuCollapse @click="handleChangeLangTW">繁體中文</li>
        <li v-b-toggle.menuCollapse @click="handleChangeLangCN">简体中文</li>
      </ul>
    </div>

      </div>
    </b-collapse>

  </div>
</template>

<script>
export default {
  name: 'siteMenu',
  props: ['id'],
  data: () => ({
  }),
  methods: {
    handleChangeLangEN() {
      this.$i18n.locale = 'en';
    },
    handleChangeLangTW() {
      this.$i18n.locale = 'tw';
    },
    handleChangeLangCN() {
      this.$i18n.locale = 'cn';
    },
    handleChangeLangBo() {
      this.$i18n.locale = 'bo';
    },
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

  #menu {

    background-color: #505444;
    padding: 20px;
    color: #ffffff;

    text-align: left;

    .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
      display: none;
    }

    .carousel-item.active, .carousel-item-next, .carousel-item-prev{
      display: none;
    }

    #menuCollapse {
      padding: 20px;
      background: rgba(65, 68, 54, 1);
      top: 0px;
      position: fixed;
      z-index: 20;
      right: 0px;
      width: 420px;
      bottom: 0px;
      overflow: scroll;
    }

    .menuList {
      clear: both;
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 100%;
    }

    .linkArea {
      flex: initial;
    }

    .language {
      color: #eab160;
      button {
        height: 20px;
      }
    }

    .menuIcon {
      color: #ffffff;
    }

    ul {
      list-style-type: none;
      li {
        margin-top: 15px;
      }
      li:hover {
        cursor: pointer;
      }
    }

    a {
      text-decoration: none;
      color: #ffffff;
    }

    .logo {
      text-align: left;
      display: inline-block;
      a {
        font-size: 1.2em;
      }
    }

    @media (max-width: 768px) {

      padding: 0.8em;

      #menuCollapse {
        padding: 0.8em;
      }

      .text {
        line-height: 1.3em;
      }

      display: flex;
      .logo {
        flex: 1;
        font-size: 0.8em;
        overflow: hidden;
        height: 2em;
      }
      .buttonArea {
        flex: initial;
        margin-left: 5px;
      }
      #menuCollapse {
        width: 100vw;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue